<template>
  <div class="content">
    <video
      ref="videoRef"
      src="@/assets/video/banner.mp4"
      autoplay
      muted
      playsinline
      class="banner"
    />

    <p class="centered-text">
      実績と信頼が築く、お客様と未来への新たな絆
    </P>

    <div class="arrow-container">
      <img
        src="@/assets/images/toppage-banner-arrow.png"
        alt="Arrow"
        class="arrow"
      >
    </div>
  </div>
</template>
    
<script>
    
export default {
    name: "BannerView",
    components: {
    },
    mounted () {
        this.$refs.videoRef.removeAttribute("loop"); // 移除 loop，手动控制循环

        this.$refs.videoRef.addEventListener("ended", () => {
            this.$refs.videoRef.currentTime = 0;
            this.$refs.videoRef.play();
        });
    },
}
</script>

<style lang="scss" scoped>
 .content{
  background: #818eff;
  position: relative;
  display: inline-block;

  .banner {
      width: 100vw;
      height: auto;
      display: block;
      max-height: calc(100vh);
      min-height: 60vh;
      object-fit: cover;
      background-color: white;
      object-fit: cover;
  }

  .centered-text {
    position: absolute;
    top: 20%;
    left: 40%;
    transform: translate(-50%, -50%);
    color: white; 
    font-size: 48px; 
    text-align: center;
    font-weight: bold; /* 字体加粗 */
  }

  .arrow-container {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);

    .arrow {
      width: 40px;
      animation: fade-move 2s infinite ease-in-out;
    }
  }

  @keyframes fade-move {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  50% {
    opacity: 0.5;
    transform: translateY(10px);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

 }

 @media all and (max-width: 1060px) {
  .content{
    .centered-text {
      font-size: 16px; 
      transform: translate(0%, 0%);
      left: 0px;
      width: 100%;
    }
  }
  .arrow-container {
    display: none;
  }
 }

</style>
    